module.exports = __webpack_public_path__ + "img/paypal-light_x2.785f7fd7.svg";